import { render, staticRenderFns } from "./StaffManageDetail.vue?vue&type=template&id=1d462a74&scoped=true"
import script from "./StaffManageDetail.vue?vue&type=script&lang=ts"
export * from "./StaffManageDetail.vue?vue&type=script&lang=ts"
import style0 from "./StaffManageDetail.vue?vue&type=style&index=0&id=1d462a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d462a74",
  null
  
)

export default component.exports